import { render, staticRenderFns } from "./TableDetail.vue?vue&type=template&id=04c92b9c&scoped=true"
import script from "./TableDetail.vue?vue&type=script&lang=js"
export * from "./TableDetail.vue?vue&type=script&lang=js"
import style0 from "./TableDetail.vue?vue&type=style&index=0&id=04c92b9c&prod&scoped=true&lang=scss"
import style1 from "./TableDetail.vue?vue&type=style&index=1&id=04c92b9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c92b9c",
  null
  
)

export default component.exports